//
// Copyright (c) 2025 Emplifi, Inc.
//

import { Plugin } from "ckeditor5";
import CollapsibleSectionEditing from "./collapsibleSectionEditing";
import CollapsibleSectionUi from "./collapsibleSectionUi";

export default class CollapsibleSection extends Plugin {
  static get requires() {
    return [CollapsibleSectionEditing, CollapsibleSectionUi];
  }

  static get pluginName() {
    return "CollapsibleSection";
  }
}
